

const Aboutpage = () => {
  return (
    <div className="about">
        <h3 className="about__title">ABOUT THE PROJECT</h3>
      <div className="about__info">
        <p>BINGE</p>
        <div>
          <p>This application helps a user to search for different shows and find information about them like the rating and genre of the show. 
             Things learnt from app build: </p>
          <ul>
            <li>React (create-react-app)</li>
            <li>Basic CSS & HTML</li>
            <li>Axios AJAX Request</li>
            <li>TVMAZE API (https://www.tvmaze.com/api)</li>
            <li>React Router</li>
            <li>React Context API</li>
            <li>Deploying to Netlify</li>
          </ul>
        </div>
      </div>
      
      
      
      
      </div>
  )
}

export default Aboutpage